var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',_vm._g(_vm._b({attrs:{"color":_vm.color(_vm.cuenta.estado),"outlined":_vm.outlined(_vm.cuenta.estado),"dark":""}},'v-chip',_vm.$attrs,false),_vm.$listeners),[_vm._v(" "+_vm._s(_vm.$payload.estadoCuenta(_vm.cuenta.estado))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }